"use client";
import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { Button, ButtonProps } from "./button";

interface ShimmerButtonProps extends ButtonProps {
  shimmer?: boolean;
  shimmerColor?: string;
}

export function ShimmerButton({
  children,
  className,
  shimmer = true,
  shimmerColor,
  ...props
}: ShimmerButtonProps) {
  return (
    <Button
      className={cn(
        "relative overflow-hidden",
        shimmer && "group",
        className
      )}
      {...props}
    >
      {shimmer && (
        <motion.div
          className="absolute inset-0 -top-1 -bottom-1 w-1/2 rotate-12 opacity-30"
          style={{
            background: `linear-gradient(90deg, transparent, ${
              shimmerColor || "hsl(var(--primary-foreground))"
            }, transparent)`,
          }}
          initial={{ x: "-200%" }}
          whileHover={{ x: "200%" }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        />
      )}
      <span className="relative z-10">{children}</span>
    </Button>
  );
}